import script from "./TagCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TagCardModal.vue?vue&type=script&setup=true&lang=js"

import "./TagCardModal.vue?vue&type=style&index=0&id=71c9552a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c9552a"]])

export default __exports__